import { Pipe, PipeTransform } from '@angular/core';
import { FeatureFlagService } from "shared/feature-flagging/feature-flag.service";
import { FeatureFlags } from "shared/feature-flagging/feature-flags";

@Pipe({
    name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform{
    constructor(private _featureFlagService: FeatureFlagService) { }

    transform(value: string) {
        if (value === null)
            return '';

        const numeric = value.replace(/\D/g, '');

        // Ten Digit match
        let array = numeric.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (array)
            return '(' + array[1] + ') ' + array[2] + '-' + array[3];

        // Eleven digit match
        array = numeric.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
        if (array)
            return `${array[1]} (${array[2]}) ${array[3]}-${array[4]}`;

        return value;
    }
}
